/**
 * Public barrel export for the shared player-filter body.
 * @module components/organisms/shared/PlayerFilterSections
 */
export { default } from "./PlayerFilterSectionsView";
export type {
  PlayerFilterSectionsViewProps,
  SectionKey,
} from "./PlayerFilterSectionsView";
